import { createUserField } from "../../../../components/workflow/WorkflowPicker";
import {
    AsyncObjectType, FormField, FormFieldType, FormFieldVisibility,
} from "../../../../__generated__/api";

export enum ExecutorFields {
    CAN_SET,
    CANT_SET
}

export default function createFormFields(formFields: FormField[], executor = ExecutorFields.CANT_SET) {
    return [
        {
            id: "urn:fq:form-field-group:request",
            label: "Request Fields",
            description: "The fields entered by the end user.",
            input: formFields
                .concat([
                    !formFields.some(row => row.id === "urn:fq:form-field:status") ? {
                        id: "urn:fq:form-field:status",
                        name: "Status",
                        type: FormFieldType.Text,
                        isSystemField: true,
                        visibility: FormFieldVisibility.Private,
                        asyncObjectType: AsyncObjectType.ChatStatus,
                    } : undefined,
                    !formFields.some(row => row.id === "urn:fq:form-field:priority") ? {
                        id: "urn:fq:form-field:priority",
                        name: "Priority",
                        type: FormFieldType.Text,
                        isSystemField: true,
                        visibility: FormFieldVisibility.Private,
                        asyncObjectType: AsyncObjectType.Priority,
                    } : undefined,
                    !formFields.some(row => row.id === "urn:fq:form-field:subject") ? {
                        id: "urn:fq:form-field:subject",
                        name: "Subject",
                        type: FormFieldType.Text,
                        isSystemField: true,
                        visibility: FormFieldVisibility.Private,
                    } : undefined,
                    !formFields.some(row => row.id === "urn:fq:form-field:description") ? {
                        id: "urn:fq:form-field:description",
                        name: "Description",
                        type: FormFieldType.LongText,
                        isSystemField: true,
                        visibility: FormFieldVisibility.Private,
                    } : undefined,
                    !formFields.some(row => row.id === "urn:fq:form-field:ticket-number") ? {
                        id: "urn:fq:form-field:ticket-number",
                        name: "Ticket number",
                        type: FormFieldType.Text,
                        isSystemField: true,
                        visibility: FormFieldVisibility.Private,
                    } : undefined,
                    !formFields.some(row => row.id === "urn:fq:form-field:ticket-guest-url") ? {
                        id: "urn:fq:form-field:ticket-guest-url",
                        name: "Guest Ticket URL",
                        type: FormFieldType.Text,
                        isSystemField: true,
                        visibility: FormFieldVisibility.Private,
                    } : undefined,
                    !formFields.some(row => row.id === "urn:fq:form-field:ticket-agent-url") ? {
                        id: "urn:fq:form-field:ticket-agent-url",
                        name: "Agent Ticket URL",
                        type: FormFieldType.Text,
                        isSystemField: true,
                        visibility: FormFieldVisibility.Private,
                    } : undefined,

                    !formFields.some(row => row.id === "urn:fq:form-field:created-date") ? {
                        id: "urn:fq:form-field:created-date",
                        name: "Create Date",
                        type: FormFieldType.Date,
                        isSystemField: true,
                        visibility: FormFieldVisibility.Private,
                    } : undefined,
                    !formFields.some(row => row.id === "urn:fq:form-field:first-response-date") ? {
                        id: "urn:fq:form-field:first-response-date",
                        name: "First Response Date",
                        type: FormFieldType.Date,
                        isSystemField: true,
                        visibility: FormFieldVisibility.Private,
                    } : undefined,
                    {
                        id: "urn:fq:form-field:fields",
                        name: "Field Name",
                        type: FormFieldType.AsyncDropdown,
                        asyncObjectType: AsyncObjectType.FieldInContext,
                        isSystemField: true,
                        visibility: FormFieldVisibility.Private,
                        options: formFields.map(field => ({
                            label: field.name,
                            value: field.id,
                        })),
                    },
                ].filterNull()),
        },
        createUserField("Requester Fields", "Information about the requester.", "requestor"),
        createUserField("Creator Fields", "Information about the creator.", "creator"),
        createUserField("Assignee Fields", "If the ticket is assigned, information about the current assignee.", "assignee"),

        executor === ExecutorFields.CANT_SET
            ? undefined
            : createUserField("Executor Fields", "Information about user what executed this action.", "executed-by"),
    ].filterNull();
}
